import { createApp } from 'vue'
import miniCart from './mini-cart.vue';
import cartStore from './store'
import focusTrap from '../../utils/focus-trap';

export default () => {
  createApp(miniCart).use(cartStore).directive('focus-trap', focusTrap).mount("vue-mini-cart")
}